export default {
	path: '/',
	icon: '',
	meta: {
		title: '研究院'
	},
	children: [
		{
			path: '/order/handout-yanjiu',
			name: 'HandoutYanjiuIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/order/educationalAdministration/handout-yanjiu'),
			meta: {
				title: '讲义管理'
			}
		},
		{
			path: '/order/courseSchedulingManagement-yanjiu',
			name: 'CourseSchedulingManagementYanjuIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () =>
				import('@/views/order/educationalAdministration/courseSchedulingManagement-yanjiu'),
			meta: {
				title: '排课管理'
			}
		},
		{
			path: '/teacher/archive',
			name: 'facultyRecordsIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/academy/facultyRecords'),
			meta: {
				title: '师资档案管理'
			}
		},
		// {
		// 	path: '/order/special_course_hours',
		// 	name: 'ScheduleHoursIndex',
		// 	icon: '',
		// 	ignore: true, //忽略权限校验
		// 	component: () => import('@/views/order/educationalAdministration/specialScheduling'),
		// 	meta: {
		// 		title: '特殊排课'
		// 	}
		// },
		{
			path: '/',
			icon: '',
			ignore: true, //忽略权限校验
			component: '',
			meta: {
				title: '老师管理'
			},
			children: [
				{
					path: '/AC/teacherQz',
					name: 'qzTeacherIndex',

					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/academy/teacher/teacherQz'),
					meta: {
						title: '全职老师管理'
					}
				},
				{
					path: '/AC/teacherJz',
					name: 'jzTeacherIndex',

					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/academy/teacher/teacherJz'),
					meta: {
						title: '兼职老师管理'
					}
				},
				{
					path: '/AC/lessonList',
					name: 'LessonListIndex',
					icon: '',
					ignore: true,
					component: () => import('@/views/order/educationalAdministration/lessonList'),
					// component: () => import('@/views/order/educationalAdministration/lessonManagement'),
					meta: {
						title: '课时列表'
					}
				},
				{
					path: '/AC/lessonVerification',
					name: 'LessonVerificationIndex',

					icon: '',
					ignore: true,
					component: () => import('@/views/order/educationalAdministration/lessonVerification'),
					meta: {
						title: '课时核对'
					}
				}
			]
		},
		{
			path: '/AC/subject',
			name: 'SubjectIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/academy/subject'),
			meta: {
				title: '学科管理'
			}
		}
		// {
		// 	path: '/AC/course',
		// 	icon: '',
		// 	ignore: true, //忽略权限校验
		// 	component: () => import('@/views/erp/coursePlanner/plan'),
		// 	meta: {
		// 		title: '排课管理'
		// 	}
		// }
	]
}
